import api from '@/api'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
export default {
  props: ['value'],
  data() {
    return {
      show: false,
      showAdminStartTimeDialog: false,
      showAdminEndTimeDialog: false,
      loadingUser: false,
      subgroupKey: 1,
      user: {
        userid: null,
        password: null,
        group: null,
        subgroup: null
        // adminstarttime: null,
        // adminendtime: null
      },
      backdoor: 0,
      privilege: {
        role: ''
      }
    }
  },
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      agentGroup: 'getAgentGroup',
      loadingAgentGroup: 'getLoadingAgentGroup',
      agentSubGroup: 'getAgentSubgroup',
      loadingAgentSubGroup: 'getLoadingAgentSubgroup',
      agents: 'getAgent',
      loadingAgent: 'getLoadingAgent'
    }),
    filterSubGroup() {
      this.backdoor
      if (this.user.group) {
        return this.agentSubGroup.filter((el) => {
          return el.admingroupid == this.user.group.id
        })
      } else {
        return []
      }
    }
  },
  mounted() {
    this.backdoor++
    if (this.value) {
      this.user = {
        userid: this.value.adminid
      }
      var group = this.agentGroup.find((el) => {
        return el.id == this.value.admingroupid
      })

      this.user.group = group ? group : null
      var subgroup = this.agentSubGroup.find((el) => {
        return el.id == this.value.adminsubgroupid
      })
      this.user.subgroup = subgroup ? subgroup : null

      try {
        if (this.value.privilege) {
          this.privilege = JSON.parse(this.value.privilege)
        } else {
          this.privilege = {
            role: ''
          }
        }
      } catch (error) {
        this.privilege = {
          role: ''
        }
      }

      if (!this.privilege.hasOwnProperty('role')) {
        Object.assign(this.privilege, { role: '' })
      }
    }

    this.cached_user = JSON.stringify(this.user)
    this.cached_privilege = JSON.stringify(this.privilege)
  },
  methods: {
    onChangeGroup(val) {
      var vm = this
      vm.user.subgroup = null
      vm.backdoor++
    },
    onChangeSubGroup(val) {
      this.$forceUpdate()
      // this.ticket.subgroup
    },
    onCancel() {
      this.show = false
      this.user = JSON.parse(this.cached_user)
      this.privilege = JSON.parse(this.cached_privilege)

      if (this.user.admingroupid) {
        this.user.group = this.agentGroup.find((el) => {
          return el.id == this.user.admingroupid
        })
      }

      if (this.user.adminsubgroupid) {
        this.user.subgroup = this.agentSubGroup.find((el) => {
          return el.id == this.user.adminsubgroupid
        })
      }
    },
    createadminuser(data) {
      return new Promise((resolve, reject) => {
        api.createadminuser(data, (error, response) => {
          if (error) {
            reject(error)
          }

          // if (error && error.message) {
          //   this.$swal.fire({
          //     text: error.message
          //   })
          //   reject(response.reason)
          // }
          resolve(response)
        })
      })
    },
    changeprivilegeadminuser(data) {
      return new Promise((resolve, reject) => {
        api.changeprivilegeadminuser({ data: data }, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    },
    async onSave() {
      var vm = this
      let result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }

      this.loadingUser = true
      try {
        var data = {}

        var privilege = { ...this.privilege }

        var pageid = this.selectedBot.pageid
        if (this.type == 'add') {
          data = {
            userid: this.user.userid,
            password: this.user.password,
            pageid,
            privilege: JSON.stringify(privilege),
            admingroupid: this.user.group ? this.user.group.id : null,
            adminsubgroupid: this.user.subgroup ? this.user.subgroup.id : null
            // adminstarttime: this.user.adminstarttime ? this.user.adminstarttime + ':00+07:00' : null,
            // adminendtime: this.user.adminendtime ? this.user.adminendtime + ':00+07:00' : null
          }

          var responseUser = await this.createadminuser(data)
          this.$emit('addUser')
          this.user = {
            userid: null,
            password: null,
            group: null,
            subgroup: null
            // adminstarttime: null,
            // adminendtime: null
          }
          this.privilege = {
            role: ''
          }
        } else {
          data = {
            userid: this.user.userid,
            pageid,
            privilege: JSON.stringify(privilege),
            admingroupid: this.user.group ? this.user.group.id : null,
            adminsubgroupid: this.user.subgroup ? this.user.subgroup.id : null
            // adminstarttime: this.user.adminstarttime ? this.user.adminstarttime + ':00+07:00' : null,
            // adminendtime: this.user.adminendtime ? this.user.adminendtime + ':00+07:00' : null
          }

          var responseUser = await this.changeprivilegeadminuser(data)
          if (this.user.userid == this.$store.state.userid) {
            vm.$swal
              .fire({
                text: 'เข้าสู่ระบบใหม่อีกครั้งเพื่อเปลี่ยนแปลงข้อมูล'
              })
              .then(async () => {
                await vm.$store.dispatch('logout')
                var isFacebook = vm.$store.state.isFacebook
                if (
                  vm.$router.history.current.name != 'login' ||
                  vm.$router.history.current.name != 'nigol'
                ) {
                  if (isFacebook) {
                    vm.$router.push('/login')
                  } else {
                    vm.$router.push('/nigol')
                  }
                }
              })
          }
          this.$emit('editUser')
        }

        this.show = false
        this.cached_user = JSON.stringify(this.user)
        this.cached_privilege = JSON.stringify(this.privilege)
      } catch (error) {
        console.log(error.message)
        this.$swal.fire({ text: error.message })
        // console.error(error)
      }
      this.loadingUser = false
    }
  },
  watch: {
    show(newVal) {
      if (newVal) this.errors.clear()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/Agentmanagement/ManageUser.js